import React from 'react';
import { connect } from 'react-redux';
import { DBTextAreaObjective, ObjectiveFlag, DBRadioButton, DBDropDown } from '_components';
import styles from './Common.module.css'

class SpeechOralPeripheralExam extends React.Component {

    render() {
        return (
            <div>
                <div className={styles.formRowSetting}>
                    <div className={styles.flgCol}>
                        <ObjectiveFlag className={styles.flag} flagged={this.props.flagged} flagText='Oral Peripheral Exam' />
                    </div>
                    <div className={styles.colHeader}>
                        <DBRadioButton
                            noteId={this.props.noteId}
                            selectedValue={'WNL'}
                            entityKeyColumn='OSNO'
                            entity='PTOBJECTIVESPEECH'
                            field='OSORASTATUS'
                            entityKeyValue={this.props.osno}
                            label='WNL'
                            className={styles.radio}
                        />
                    </div>

                    <div className={styles.colRadio}>

                        <DBRadioButton
                            noteId={this.props.noteId}
                            selectedValue={'Impaired'}
                            entityKeyColumn='OSNO'
                            entity='PTOBJECTIVESPEECH'
                            field='OSORASTATUS'
                            entityKeyValue={this.props.osno}
                            label='Impaired'
                            className={styles.radio}
                        />
                    </div>
                </div>

                <div className={styles.formRowSetting}>
                    <div className={styles.flgCol} />
                    <div className={styles.colHeader}>
                        Comments
                    </div>
                </div>
                <div className={styles.formRowSetting}>
                    <div className={styles.col} />
                    <div className={styles.colRadio}>
                        <DBTextAreaObjective
                            noteId={this.props.noteId}
                            entity='PTOBJECTIVESPEECH'
                            entityKeyColumn='OSNO'
                            entityKeyValue={this.props.osno}
                            field='OSORACOMMENTS'
                            className={styles.textarea}
                        />
                    </div>
                </div>

                <div className={styles.formRowSetting}>
                    <div className={styles.flgCol}>
                        <ObjectiveFlag className={styles.flag} flagged={this.props.facialWeaknessFlagged} flagText='Facial Weakness' />
                    </div>

                    <div className={styles.colHeader}>
                        Facial Weakness
                    </div>

                    <div className={styles.colRadio}>
                        <DBDropDown
                            field='OSORAFACIALWEAK'
                            noteId={this.props.noteId}
                            entity='PTOBJECTIVESPEECH'
                            entityKeyColumn='OSNO'
                            className={styles.dropDownSize}
                            entityKeyValue={this.props.osno}
                            customOptions={
                                [
                                    { id: 1, value: 'WNL' },
                                    { id: 2, value: 'Right' },
                                    { id: 3, value: 'Left' }
                                ]
                            }
                        />

                    </div>
                </div>

                <div className={styles.formRowSetting}>
                    <div className={styles.flgCol}>
                        <ObjectiveFlag className={styles.flag} flagged={this.props.facialSensationFlagged} flagText='Facial Sensation' />
                    </div>

                    <div className={styles.colHeader}>
                        Facial Sensation
                    </div>

                    <div className={styles.colRadio}>
                        <DBDropDown
                            field='OSORAFACIALSENS'
                            noteId={this.props.noteId}
                            entity='PTOBJECTIVESPEECH'
                            entityKeyColumn='OSNO'
                            className={styles.dropDownSize}
                            entityKeyValue={this.props.osno}
                            customOptions={
                                [
                                    { id: 1, value: 'WNL' },
                                    { id: 2, value: 'Reduced' }
                                ]
                            }
                        />

                    </div>
                </div>

                <div className={styles.formRowSetting}>
                    <div className={styles.flgCol}>
                        <ObjectiveFlag className={styles.flag} flagged={this.props.teethFlagged} flagText='Teeth/Dentures' />
                    </div>

                    <div className={styles.colHeader}>
                        Teeth/Dentures
                    </div>

                    <div className={styles.colRadio}>
                        <DBDropDown
                            field='OSORATEETH'
                            noteId={this.props.noteId}
                            entity='PTOBJECTIVESPEECH'
                            entityKeyColumn='OSNO'
                            className={styles.dropDownSize}
                            entityKeyValue={this.props.osno}
                            customOptions={
                                [
                                    { id: 1, value: 'Present' },
                                    { id: 2, value: 'Absent' }
                                ]
                            }
                        />

                    </div>
                </div>


                <div className={styles.formRowSetting}>
                    <div className={styles.flgCol}>
                        <ObjectiveFlag className={styles.flag} flagged={this.props.lipPurFlagged} flagText='Lip Pursing' />
                    </div>

                    <div className={styles.colHeader}>
                        Lip Pursing
                    </div>

                    <div className={styles.colRadio}>
                        <DBDropDown
                            field='OSORALIPPUR'
                            noteId={this.props.noteId}
                            className={styles.dropDownSize}
                            entity='PTOBJECTIVESPEECH'
                            entityKeyColumn='OSNO'
                            entityKeyValue={this.props.osno}
                            customOptions={
                                [
                                    { id: 1, value: 'WNL' },
                                    { id: 2, value: 'Reduced' },
                                    { id: 3, value: 'Uncoordinated' }
                                ]
                            }
                        />

                    </div>
                </div>


                <div className={styles.formRowSetting}>
                    <div className={styles.flgCol}>
                        <ObjectiveFlag className={styles.flag} flagged={this.props.lipRetractionFlagged} flagText='Lip Retraction' />
                    </div>

                    <div className={styles.colHeader}>
                        Lip Retraction
                    </div>

                    <div className={styles.colRadio}>
                        <DBDropDown
                            field='OSORALIPRETRACT'
                            noteId={this.props.noteId}
                            entity='PTOBJECTIVESPEECH'
                            className={styles.dropDownSize}
                            entityKeyColumn='OSNO'
                            entityKeyValue={this.props.osno}
                            customOptions={
                                [
                                    { id: 1, value: 'WNL' },
                                    { id: 2, value: 'Reduced' },
                                    { id: 3, value: 'Uncoordinated' }
                                ]
                            }
                        />

                    </div>
                </div>


                <div className={styles.formRowSetting}>
                    <div className={styles.flgCol}>
                        <ObjectiveFlag className={styles.flag} flagged={this.props.droolingFlagged} flagText='Drooling' />
                    </div>

                    <div className={styles.colHeader}>
                        Drooling
                    </div>

                    <div className={styles.colRadio}>
                        <DBDropDown
                            field='OSORADROOLING'
                            noteId={this.props.noteId}
                            entity='PTOBJECTIVESPEECH'
                            className={styles.dropDownSize}
                            entityKeyColumn='OSNO'
                            entityKeyValue={this.props.osno}
                            customOptions={
                                [
                                    { id: 1, value: 'Yes' },
                                    { id: 2, value: 'No' }
                                ]
                            }
                        />

                    </div>
                </div>


                <div className={styles.formRowSetting}>
                    <div className={styles.flgCol}>
                        <ObjectiveFlag className={styles.flag} flagged={this.props.tongueSensFlagged} flagText='Tongue Sensation' />
                    </div>

                    <div className={styles.colHeader}>
                        Tongue Sensation
                    </div>

                    <div className={styles.colRadio}>
                        <DBDropDown
                            field='OSORATONGUESENS'
                            noteId={this.props.noteId}
                            className={styles.dropDownSize}
                            entity='PTOBJECTIVESPEECH'
                            entityKeyColumn='OSNO'
                            entityKeyValue={this.props.osno}
                            customOptions={
                                [
                                    { id: 1, value: 'WNL' },
                                    { id: 2, value: 'Reduced R' },
                                    { id: 3, value: 'Reduced L' },
                                    { id: 4, value: 'Absent' }
                                ]
                            }
                        />

                    </div>
                </div>

                <div className={styles.formRowSetting}>
                    <div className={styles.flgCol}>
                        <ObjectiveFlag className={styles.flag} flagged={this.props.tongueProFlagged} flagText='Tongue Protrusion' />
                    </div>

                    <div className={styles.colHeader}>
                        Tongue Protrusion
                    </div>

                    <div className={styles.colRadio}>
                        <DBDropDown
                            field='OSORATONGUEPROTRUSION'
                            noteId={this.props.noteId}
                            entity='PTOBJECTIVESPEECH'
                            className={styles.dropDownSize}
                            entityKeyColumn='OSNO'
                            entityKeyValue={this.props.osno}
                            customOptions={
                                [
                                    { id: 1, value: 'WNL' },
                                    { id: 2, value: 'Deviation R' },
                                    { id: 3, value: 'Deviation L' },
                                    { id: 4, value: 'Absent' },
                                    { id: 5, value: 'Uncoordinated' }
                                ]
                            }
                        />

                    </div>
                </div>

                <div className={styles.formRowSetting}>
                    <div className={styles.flgCol}>
                        <ObjectiveFlag className={styles.flag} flagged={this.props.tongueRetFlagged} flagText='Tongue Retraction' />
                    </div>

                    <div className={styles.colHeader}>
                        Tongue Retraction
                    </div>

                    <div className={styles.colRadio}>
                        <DBDropDown
                            field='OSORATONGUERET'
                            noteId={this.props.noteId}
                            className={styles.dropDownSize}
                            entity='PTOBJECTIVESPEECH'
                            entityKeyColumn='OSNO'
                            entityKeyValue={this.props.osno}
                            customOptions={
                                [
                                    { id: 1, value: 'WNL' },
                                    { id: 2, value: 'Deviation R' },
                                    { id: 3, value: 'Deviation L' },
                                    { id: 4, value: 'Absent' },
                                    { id: 5, value: 'Uncoordinated' }
                                ]
                            }
                        />

                    </div>
                </div>


                <div className={styles.formRowSetting}>
                    <div className={styles.flgCol}>
                        <ObjectiveFlag className={styles.flag} flagged={this.props.tongueEleFlagged} flagText='Tongue Elevation' />
                    </div>

                    <div className={styles.colHeader}>
                        Tongue Elevation
                    </div>

                    <div className={styles.colRadio}>
                        <DBDropDown
                            field='OSORATONGUEELE'
                            noteId={this.props.noteId}
                            className={styles.dropDownSize}
                            entity='PTOBJECTIVESPEECH'
                            entityKeyColumn='OSNO'
                            entityKeyValue={this.props.osno}
                            customOptions={
                                [
                                    { id: 1, value: 'WNL' },
                                    { id: 2, value: 'Deviation R' },
                                    { id: 3, value: 'Deviation L' },
                                    { id: 4, value: 'Absent' },
                                    { id: 5, value: 'Uncoordinated' }
                                ]
                            }
                        />

                    </div>
                </div>


                <div className={styles.formRowSetting}>
                    <div className={styles.flgCol}>
                        <ObjectiveFlag className={styles.flag} flagged={this.props.tongueLatFlagged} flagText='Tongue Lateralization' />
                    </div>

                    <div className={styles.colHeader}>
                        Tongue Lateralization
                    </div>

                    <div className={styles.colRadio}>
                        <DBDropDown
                            field='OSORATONGUELAT'
                            className={styles.dropDownSize}
                            noteId={this.props.noteId}
                            entity='PTOBJECTIVESPEECH'
                            entityKeyColumn='OSNO'
                            entityKeyValue={this.props.osno}
                            customOptions={
                                [
                                    { id: 1, value: 'WNL' },
                                    { id: 2, value: 'Deviation R' },
                                    { id: 3, value: 'Deviation L' },
                                    { id: 4, value: 'Absent' },
                                    { id: 5, value: 'Uncoordinated' }
                                ]
                            }
                        />

                    </div>
                </div>


            </div>
        );
    }

}

function mapStateToProps(state) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let noteType = parseInt(noteId.split("_")[0]);
    let pk = parseInt(noteId.split("_")[1]);
    let osno = parseInt(Object.keys(state.entities.notes.PTOBJECTIVESPEECH)
        .find(key => (state.entities.notes.PTOBJECTIVESPEECH[key].OSEVNO === pk && noteType === 1)
            || (state.entities.notes.PTOBJECTIVESPEECH[key].OSNTNO === pk && noteType !== 1)));

    return {
        noteId: noteId,
        osno: osno,
        flagged: (state.entities.notes.PTOBJECTIVESPEECH[osno].OSORASTATUS !== undefined
            && state.entities.notes.PTOBJECTIVESPEECH[osno].OSORASTATUS !== null
            && state.entities.notes.PTOBJECTIVESPEECH[osno].OSORASTATUS !== 'WNL'),
        facialWeaknessFlagged: (state.entities.notes.PTOBJECTIVESPEECH[osno].OSORAFACIALWEAK !== undefined
            && state.entities.notes.PTOBJECTIVESPEECH[osno].OSORAFACIALWEAK !== null
            && state.entities.notes.PTOBJECTIVESPEECH[osno].OSORAFACIALWEAK !== '1'),
        facialSensationFlagged: (state.entities.notes.PTOBJECTIVESPEECH[osno].OSORAFACIALSENS !== undefined
            && state.entities.notes.PTOBJECTIVESPEECH[osno].OSORAFACIALSENS !== null
            && state.entities.notes.PTOBJECTIVESPEECH[osno].OSORAFACIALSENS !== '1'),
        teethFlagged: (state.entities.notes.PTOBJECTIVESPEECH[osno].OSORATEETH !== undefined
            && state.entities.notes.PTOBJECTIVESPEECH[osno].OSORATEETH !== null
            && (state.entities.notes.PTOBJECTIVESPEECH[osno].OSORATEETH === '1' || state.entities.notes.PTOBJECTIVESPEECH[osno].OSORATEETH === '2')),
        lipPurFlagged: (state.entities.notes.PTOBJECTIVESPEECH[osno].OSORALIPPUR !== undefined
            && state.entities.notes.PTOBJECTIVESPEECH[osno].OSORALIPPUR !== null
            && state.entities.notes.PTOBJECTIVESPEECH[osno].OSORALIPPUR !== '1'),
        lipRetractionFlagged: (state.entities.notes.PTOBJECTIVESPEECH[osno].OSORALIPRETRACT !== undefined
            && state.entities.notes.PTOBJECTIVESPEECH[osno].OSORALIPRETRACT !== null
            && state.entities.notes.PTOBJECTIVESPEECH[osno].OSORALIPRETRACT !== '1'),
        droolingFlagged: (state.entities.notes.PTOBJECTIVESPEECH[osno].OSORADROOLING !== undefined
            && state.entities.notes.PTOBJECTIVESPEECH[osno].OSORADROOLING !== null
            && (state.entities.notes.PTOBJECTIVESPEECH[osno].OSORADROOLING === '1' || state.entities.notes.PTOBJECTIVESPEECH[osno].OSORADROOLING === '2')),
        tongueSensFlagged: (state.entities.notes.PTOBJECTIVESPEECH[osno].OSORATONGUESENS !== undefined
            && state.entities.notes.PTOBJECTIVESPEECH[osno].OSORATONGUESENS !== null
            && state.entities.notes.PTOBJECTIVESPEECH[osno].OSORATONGUESENS !== '1'),
        tongueProFlagged: (state.entities.notes.PTOBJECTIVESPEECH[osno].OSORATONGUEPROTRUSION !== undefined
            && state.entities.notes.PTOBJECTIVESPEECH[osno].OSORATONGUEPROTRUSION !== null
            && state.entities.notes.PTOBJECTIVESPEECH[osno].OSORATONGUEPROTRUSION !== '1'),
        tongueRetFlagged: (state.entities.notes.PTOBJECTIVESPEECH[osno].OSORATONGUERET !== undefined
            && state.entities.notes.PTOBJECTIVESPEECH[osno].OSORATONGUERET !== null
            && state.entities.notes.PTOBJECTIVESPEECH[osno].OSORATONGUERET !== '1'),
        tongueEleFlagged: (state.entities.notes.PTOBJECTIVESPEECH[osno].OSORATONGUEELE !== undefined
            && state.entities.notes.PTOBJECTIVESPEECH[osno].OSORATONGUEELE !== null
            && state.entities.notes.PTOBJECTIVESPEECH[osno].OSORATONGUEELE !== '1'),
        tongueLatFlagged: (state.entities.notes.PTOBJECTIVESPEECH[osno].OSORATONGUELAT !== undefined
            && state.entities.notes.PTOBJECTIVESPEECH[osno].OSORATONGUELAT !== null
            && state.entities.notes.PTOBJECTIVESPEECH[osno].OSORATONGUELAT !== '1'),
    };
}

const connectedSpeechOralPeripheralExam = connect(mapStateToProps)(SpeechOralPeripheralExam);
export { connectedSpeechOralPeripheralExam as SpeechOralPeripheralExam };


